export default {
    _cachedItems: {},

    async get(url) {
        if (this._cachedItems[url]) {
            return this._cachedItems[url]
        }

        const res = await axios.get(url)
        this._cachedItems[url] = res
        return res
    }
}